import React from 'react'
import Dropdown, {
    MenuItem,
} from '@trendmicro/react-dropdown'
import '!style-loader!css-loader!./dropdown.css'
import { mapProps, compose } from 'recompose'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'

const showToTeam = compose(
    mapProps((props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.ADMIN_ACCESS
      ]
    })),
    showOnAnyRoles
  )

const RestrictedDeleteOption = showToTeam(MenuItem)

const publicMenuItems = (
    items, 
    selected, 
    setDefaultView,
    deleteCustomView
    ) => {
    return (
        items.map((item, idx) => 
            <MenuItem
                key={idx}
                eventKey={item.value}
                active={selected === item.value }
            >
                {item.label}
                <Dropdown style={{float: 'right', paddingLeft: '20px'}} onClick={event => event.stopPropagation()}>
                    <Dropdown.Toggle
                        noCaret
                        btnSize='sm'
                        compact
                    >
                        
                        ...
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <MenuItem onSelect={() => setDefaultView(item.value)}>Set Default</MenuItem>
                        <RestrictedDeleteOption onSelect={() => deleteCustomView(item.value)}>Delete</RestrictedDeleteOption>
                    </Dropdown.Menu> 
                </Dropdown>
            </MenuItem>
        )
    )
}

const menuItems = (
    items, 
    defaultView, 
    deleteCustomView, 
    setDefaultView
    ) => {
    return (
        items.map((item, idx) =>
            <MenuItem
                key={idx}
                eventKey={item.value}
                active={defaultView === item.value}
            >
                {item.label}
                <Dropdown style={{float: 'right', paddingLeft: '20px'}} onClick={event => event.stopPropagation()}>
                    <Dropdown.Toggle
                        noCaret
                        btnSize='sm'
                        compact
                    >
                        ...
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {/* <MenuItem onSelect={() => editCustomView(item.value)}>Edit</MenuItem> */}
                        <MenuItem onSelect={() => deleteCustomView(item.value)}>Delete</MenuItem>
                        <MenuItem onSelect={() => setDefaultView(item.value)}>Set Default</MenuItem>
                    </Dropdown.Menu>
                </Dropdown>
            </MenuItem>
        )
    )
}

const NestedDropdown = ({ 
    source, 
    defaultView, 
    onChange, 
    deleteCustomView, 
    editCustomView, 
    publicSource, 
    setDefaultView, 
    selected 
    }) => {
    let allSources = source.concat(publicSource)
    let selectedView

    // refactor
    if (selected === '' || allSources.find(source => source.value === selected) === undefined) {
        selectedView = 'Manage Views'
    } else {
        selectedView = allSources.find(source => source.value === selected).label
    }

    return (
        <Dropdown onSelect={eventKey => onChange(eventKey)}>
            <Dropdown.Toggle btnStyle='flat' title={selectedView} />
            <Dropdown.Menu>
                <MenuItem header>Private Views</MenuItem>
                {menuItems(source, defaultView, deleteCustomView, editCustomView, setDefaultView)}
                <MenuItem divider />
                <MenuItem header>Public Views</MenuItem>
                {publicMenuItems(publicSource, defaultView, setDefaultView, deleteCustomView)}
                <MenuItem divider />
                <MenuItem eventKey={'addView'}>Save View</MenuItem>
            </Dropdown.Menu>
        </Dropdown> 
    )
}

export default NestedDropdown